import React from 'react';

export function useAccordionState<T>(initialValue?: T): [T | undefined, (value: T) => void] {
	const [selectedValue, setSelectedValue] = React.useState<T | undefined>(initialValue);
	return [selectedValue, (value: T) => setSelectedValue(value === selectedValue ? undefined : value)];
}
